<ng-container *transloco="let t">
  <footer>
    <div class="container-lg">
      <div class="row">
        <div class="footer-col col-xl-4 col-md-6">
          <span class="heading-size-4">{{ t('footer_eservices_header') }}</span>
          <ul class="footer-link-list">
            <li>
              <a href="{{ env.etjansterCommonUrl }}/public/fragor-och-svar">
                {{ t('footer_faq') }}
              </a>
            </li>
            <li>
              <a [href]="ansokanGuideUrl$ | async" target="_blank">
                {{ t('footer_application_guide') }}
              </a>
            </li>
            <li>
              <a
                href="{{ env.etjansterCommonUrl }}/public/om-vinnovas-etjanster"
              >
                {{ t('footer_about') }}
              </a>
            </li>
            <li>
              <a
                href="{{ env.etjansterCommonUrl }}/public/juridisk-information"
              >
                {{ t('footer_legal_information') }}
              </a>
            </li>
            <li>
              <a [href]="gdprUrl$ | async" target="_blank">
                {{ t('footer_gdpr') }}
              </a>
            </li>
          </ul>
        </div>
        <div class="footer-col col-xl-4 col-md-6">
          <span class="heading-size-4">{{ t('footer_contact_header') }}</span>
          <a [attr.href]="'mailto:' + t('footer_email_vinnova')">{{
            t('footer_email_vinnova')
          }}</a>
          <br />
          <span>{{ t('footer_tele_vinnova') }}</span>
          <br />
          <span>{{ t('footer_opening_hours_vinnova') }}</span>
          <br />
          <br />
          <span>{{ t('footer_address_line_1') }}</span>
          <br />
          <span>{{ t('footer_address_line_2') }}</span>
        </div>
        <div class="footer-col col-xl-4 col-md-6">
          <span class="heading-size-4">{{ t('footer_support_header') }}</span>
          <a [attr.href]="'mailto:' + t('footer_email_support')">{{
            t('footer_email_support')
          }}</a>
          <br />
          <span>{{ t('footer_tele_support') }}</span
          ><br />
          <span>{{ t('footer_opening_hours_support') }}</span>
        </div>
      </div>
    </div>
  </footer>
</ng-container>
